import React, { Component } from 'react';
import { adminservice } from '../../../services/admin.service';

class DeleteMember extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedMemberToDelete:0,
            showSuccessMessage:false,
            showDeleteModel:true,
        };
    }
    componentDidMount=()=>{
        this.setState({
            selectedMemberToDelete : this.props.selectedMemberToDelete,
            showDeleteModel:this.props.showDeleteModel
        })
    }

    deleteMember=async()=>{
        this.setState({isLoading:true});
        var response=await adminservice.DeleteMember(this.state.selectedMemberToDelete)
        if(response.status === 200){
            this.props.getMemberList();
            this.props.closeDeleteModel()
            this.setState({
                showSuccessMessage:false,
            });
        }
        this.setState({isLoading:false});
    }

    render() {
        const{
            showSuccessMessage,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal1">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-md">
                        <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header" style={{padding:'9px 1rem'}}>
                            <h4 className="modal-title">Delete Member</h4>
                            <button type="button" className="btn-close" onClick={()=>this.props.closeDeleteModel()}>X</button>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body" style={{overflowX: 'auto', padding: '30px'}}>
                            <h5 style={{fontWeight: 400, fontSize: '22px'}}>Are you sure you want to delete the Member?</h5>
                            {showSuccessMessage && (
                                <div id="thank_you" className="alert alert-success alert-dismissible" style={{ fontSize: '16px'}}>
                                    {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                    <button type="button" className="btn-close" data-bs-dismiss="alert" />
                                    Member deleted.
                                </div>
                            )}
                        </div>
                        {/* Modal footer */}
                        <div className="modal-footer">
                            <button type="button" className="btn Submit-btn" onClick={()=>this.deleteMember()}>OK</button>
                            <button type="button" className="btn Cancel-btn" onClick={()=>this.props.closeDeleteModel()}>CANCEL</button>
                        </div>
                        </div>
                    </div>
                    </div>
        );
    }
}

export default DeleteMember;